import React from 'react';
import { AgendaIcon, ArrowIcon, TriangleIcon } from '../../../eagerlyIcons/src/__generated__/icons';

import { parseEntities, parseDateDesktopShort, toSmallDateDisplay, toSmallDateDayDisplay, toSmallDateMonthDisplay, toSmallDateDisplayYear, getLatest } from '../../utils/helpers';

export const ZeistDateComponent = ({bold, normal}) => {

	return (
		<>
			<div>{normal}</div>
			<div className="agenda-item-bold">{bold}</div>
		</>
	)
}

const BigTile = ({ movie, showDate, id, activeFilterDate, currentConfig, releaseDate, handleTagClick, animationDelay, detailPage }) => {


	const printDate = (date) => {
		if (releaseDate) {
			const parsedDate = parseDateDesktopShort(date);
			if (currentConfig.year_in_tile) return toSmallDateDisplayYear(parsedDate);
			if (currentConfig.theme === 'idea') return <ZeistDateComponent normal={toSmallDateDayDisplay(parsedDate)} bold={toSmallDateMonthDisplay(parsedDate)}/>
			return toSmallDateDisplay(parsedDate);
		} else {
			return '';
		}
	}

  return (
    <li className={`featured__item ${detailPage ? 'detailpage' : ''}`} key={id} style={animationDelay} id={`movie-${id}`}>
      <a className="featured__item_link" href={movie.permalink}>
        <article className="agenda-item">

			  	<div className="agenda-item__day-container">
					{
						showDate &&
						<>
							<h5 className="agenda-item__day">
								{ printDate(releaseDate) }
							</h5>
							<>
							{
								movie.is_festival &&
									<>
										{ currentConfig.theme === 'flint' && <ArrowIcon /> }
										<h5 className="agenda-item__day agenda-item__day-end">
											{ printDate(getLatest(movie.date_range)) }
										</h5>
									</>
							}
							</>
						</>
					}

				</div>

				<div className={`agenda-item__container ${movie.is_festival ? 'multi-day' : ''}`}>

					{/* image */}
					{!detailPage && (
						<div className={`agenda-item__image-container ${movie.is_festival ? 'multi-day' : ''}`}>
						{movie.poster_mobile ? (
							<img src={movie.poster_mobile} alt={movie.title} className="agenda-item__image agenda-item__image-mobile " />
						) : (
							<div className="agenda-item__image agenda-item__image-mobile"></div>
						)}
						{movie.poster_desktop ? (
							<img src={`${movie.poster_desktop}?${Math.random()}`} alt={movie.title} className="agenda-item__image agenda-item__image-desktop " />
							) : (
							<div className="agenda-item__image agenda-item__image-desktop"></div>
						)}
						</div>
					)}

					{/* content */}
					<div className="agenda-item__content">

						<div className="agenda-item__content-left">
							{/* tags in case of idea */}
							{ currentConfig.theme === 'idea' &&
								<div className="agenda-item__tags">
									{Object.keys(movie.tags).map((tag, index) => {
										if (tag !== 'special-no-label')
											return (
													<div
														key={index}
														className="agenda-item__tags-label p"
														data-value={movie.tags[tag]}
														data-highlight={tag === 'special' ? 'true' : 'false'}
														data-reverse={tag !== 'special' ? 'true' : 'false'}
														//   onClick={() => handleTagClick(movie.tags[tag], true)} //only activate tag, not deactivate
													>
														{parseEntities(movie.tags[tag])}
													</div>
											);
									})}
								</div>
							}

							{/* title */}
							{!detailPage && (
								<>
									<h2 className="agenda-item__title">
										{/* <a href={movie.permalink}> */}
											{parseEntities(movie.title)}
											{movie.subtitle && <span>: {parseEntities(movie.subtitle)}</span>}
										{/* </a> */}
									</h2>
								</>
							)}
							{detailPage && <h3 className="agenda-item__subtitle">{`Open: ${movie.times[0].door_open.substring(8, 10)}:${movie.times[0].door_open.substring(10, 12)}`}</h3>}

							{/* location and tags in case of flint */}
							{ currentConfig.theme === 'flint' &&
								<div className="agenda-item__details">
									{movie.times[0].location && Object.values(movie.times[0].location)[0]}
									<span>.</span>
									{Object.keys(movie.tags).map((tag, index) => {
										if (tag !== 'special-no-label') return (
											<span
												key={index}
												data-value={movie.tags[tag]}
												//   onClick={() => handleTagClick(movie.tags[tag], true)} //only activate tag, not deactivate
											>
												{parseEntities(movie.tags[tag])}
											</span>
										);
									})}
								</div>
							}

							{/* story */}
							{movie.storyline && <h3 className="agenda-item__subtitle">{parseEntities(movie.storyline)}</h3>}

							{ currentConfig.theme === 'flint' && !movie.is_festival &&
								<div className="agenda-item__buttons">
									{
										movie.times[0].status_label &&
										<div className="agenda-item__tags-label agenda-item__tags-label-status p">{movie.times[0].status_label}</div>
									}
									<button className="agenda-item__times">{movie.times[0].program_start.substring(8, 10)}:{movie.times[0].program_start.substring(10, 12)}</button>
								</div>
							}
						</div>

						<div className="agenda-item__content-right">
							<div className="agenda-item__times">
								{
									!movie.is_festival && !! movie.times[0].time_start && !! movie.times[0].time_end ?
										`${movie.times[0].time_start} - ${movie.times[0].time_end}`
										: 'Tijden'
								}
							</div>
							{ currentConfig.theme === 'idea' && <button className="agenda-item__cta"><TriangleIcon />Meer info</button> }
						</div>


					</div>
				</div>




        </article>
      </a>
    </li>
  );
};

export default BigTile;
